import React, { useState } from 'react';
import authService from '../services/authService';
import { consumeSessionExpiredFlag } from '../utils/ncDraftStore'; // #145
import Button from './ui/Button';
import './Login.css';

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [sessaoExpirou] = useState(() => consumeSessionExpiredFlag()); // #145

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await authService.login(email, password);
      onLoginSuccess(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-grid-container">
        {/* Left Column - Hero Section */}
        <div className="login-hero-column">
          {/* Main Hero Card */}
          <div className="hero-card-main">
            <div className="hero-content">
              <img
                src="/qaasa-texto-dark.png"
                alt="Qaa.sa Logo"
                className="hero-logo"
              />
              <h1 className="hero-title">
                Quality as a service,<br/>
                <span className="hero-title-accent">powered by AI</span>
              </h1>
              <p className="hero-description">
                Menos planilhas. Mais inteligência na gestão de Não-Conformidades da sua Organização.
              </p>
            </div>
            <div className="hero-decoration"></div>
          </div>

          {/* Feature Card - ISO Compliance */}
          <div className="feature-card">
            <span className="material-symbols-outlined feature-icon">verified_user</span>
            <div>
              <h3 className="feature-title">ISO 9001 Compliance</h3>
              <p className="feature-description">Estrutura técnica avançada para gestão de normas internacionais de qualidade.</p>
            </div>
          </div>

          {/* Feature Card - Sistema completo */}
          <div className="feature-card-primary">
            <div className="feature-primary-content">
              <h3 className="feature-primary-title">Não é só IA. É um sistema completo.</h3>
              <p className="feature-primary-description">Registro, workflow, eficácia, recorrência, integração de cadeia — a gestão de não-conformidades inteira em um só lugar.</p>
            </div>
            <div className="feature-primary-icon">
              <span className="material-symbols-outlined">hub</span>
            </div>
          </div>
        </div>

        {/* Right Column - Login Form */}
        <div className="login-form-column">
          <div className="login-form-header">
            <h2 className="form-title">Bem-vindo</h2>
            <p className="form-subtitle">Insira suas credenciais para acessar o ecossistema de qualidade da Qaa.sa.</p>
          </div>

          {/* #145 — aviso quando o usuário caiu aqui por sessão expirada. */}
          {sessaoExpirou && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', padding: '12px 14px', marginBottom: '16px', background: '#fffbeb', border: '1px solid #fde68a', borderLeft: '4px solid #f59e0b', borderRadius: '6px', fontSize: '13px', color: '#92400e' }}>
              <span className="material-symbols-outlined" style={{ fontSize: '18px', color: '#b45309' }}>info</span>
              <span>Sua sessão expirou. Faça login novamente — suas edições não salvas foram preservadas e poderão ser restauradas ao reabrir a NC.</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form-main">
            {/* Email Field */}
            <div className="form-group">
              <label className="form-label">E-mail Corporativo</label>
              <div className="input-wrapper">
                <span className="material-symbols-outlined input-icon">mail</span>
                <input
                  type="email"
                  className="form-input"
                  placeholder="nome@empresa.com.br"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="form-group">
              <div className="form-label-row">
                <label className="form-label">Senha</label>
                <a href="/forgot-password" className="forgot-link">Esqueceu a senha?</a>
              </div>
              <div className="input-wrapper">
                <span className="material-symbols-outlined input-icon">lock</span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
                <button 
                  type="button"
                  className="visibility-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <span className="material-symbols-outlined">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>

            {/* Remember Me */}
            <div className="remember-wrapper">
              <input
                type="checkbox"
                id="remember"
                className="remember-checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="remember" className="remember-label">
                Manter conectado neste dispositivo
              </label>
            </div>

            {/* Error Message */}
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            {/* Submit Button */}
            <Button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'ENTRANDO...' : 'ENTRAR'}
              <span className="material-symbols-outlined" style={{ marginLeft: '0.5rem' }}>arrow_forward</span>
            </Button>
          </form>

          {/* #79 — entrada do cadastro público self-service */}
          <p style={{ textAlign: 'center', marginTop: '18px', fontSize: '14px', color: '#64748b' }}>
            Não tem conta? <a href="/cadastro" className="forgot-link">Criar conta grátis</a>
          </p>

          {/* Rodapé */}
          <div className="sso-section">
            <div className="sso-content">
              <p className="version-text">© 2026 Qaa.sa Precision Architect. v2.4.0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
